import type { ComponentProps } from "react";

export function Persons(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M32 19.4678C33.4817 20.2041 34.5 21.7331 34.5 23.5C34.5 25.2669 33.4817 26.7959 32 27.5322M34 32.7664C35.5115 33.4503 36.8725 34.565 38 36M18 36C19.9465 33.5226 22.5892 32 25.5 32C28.4108 32 31.0535 33.5226 33 36M30 23.5C30 25.9853 27.9853 28 25.5 28C23.0147 28 21 25.9853 21 23.5C21 21.0147 23.0147 19 25.5 19C27.9853 19 30 21.0147 30 23.5Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function Lightning(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M25 33.5H19.5M22.5 28H18M25 22.5H20M33 19L26.4036 28.235C26.1116 28.6438 25.9656 28.8481 25.9719 29.0185C25.9774 29.1669 26.0486 29.3051 26.1661 29.3958C26.3011 29.5 26.5522 29.5 27.0546 29.5H32L31 37L37.5964 27.765C37.8884 27.3562 38.0344 27.1519 38.0281 26.9815C38.0226 26.8331 37.9514 26.6949 37.8339 26.6042C37.6989 26.5 37.4478 26.5 36.9454 26.5H32L33 19Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function Accountability(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M28 18.5001V28.0001M28 28.0001L36.5 23.2778M28 28.0001L19.5 23.2778M28 28.0001V37.5001M36.5 32.7223L28.777 28.4318C28.4934 28.2742 28.3516 28.1954 28.2015 28.1645C28.0685 28.1372 27.9315 28.1372 27.7986 28.1645C27.6484 28.1954 27.5066 28.2742 27.223 28.4318L19.5 32.7223M37 32.0586V23.9415C37 23.5989 37 23.4276 36.9495 23.2748C36.9049 23.1396 36.8318 23.0155 36.7354 22.9108C36.6263 22.7925 36.4766 22.7093 36.177 22.5429L28.777 18.4318C28.4934 18.2742 28.3516 18.1954 28.2015 18.1645C28.0685 18.1372 27.9315 18.1372 27.7986 18.1645C27.6484 18.1954 27.5066 18.2742 27.223 18.4318L19.823 22.5429C19.5234 22.7093 19.3737 22.7925 19.2646 22.9108C19.1682 23.0155 19.0951 23.1396 19.0505 23.2748C19 23.4276 19 23.5989 19 23.9415V32.0586C19 32.4013 19 32.5726 19.0505 32.7254C19.0951 32.8606 19.1682 32.9847 19.2646 33.0893C19.3737 33.2077 19.5234 33.2909 19.823 33.4573L27.223 37.5684C27.5066 37.726 27.6484 37.8047 27.7986 37.8356C27.9315 37.863 28.0685 37.863 28.2015 37.8356C28.3516 37.8047 28.4934 37.726 28.777 37.5684L36.177 33.4573C36.4766 33.2909 36.6263 33.2077 36.7354 33.0893C36.8318 32.9847 36.9049 32.8606 36.9495 32.7254C37 32.5726 37 32.4013 37 32.0586Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function ChatIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M22.0944 27.2288C22.0322 26.8282 22 26.4179 22 26C22 21.5817 25.6052 18 30.0526 18C34.4999 18 38.1052 21.5817 38.1052 26C38.1052 26.9981 37.9213 27.9535 37.5852 28.8345C37.5154 29.0175 37.4804 29.109 37.4646 29.1804C37.4489 29.2512 37.4428 29.301 37.4411 29.3735C37.4394 29.4466 37.4493 29.5272 37.4692 29.6883L37.8717 32.9585C37.9153 33.3125 37.9371 33.4895 37.8782 33.6182C37.8266 33.731 37.735 33.8205 37.6211 33.8695C37.4911 33.9254 37.3146 33.8995 36.9617 33.8478L33.7765 33.3809C33.6101 33.3565 33.527 33.3443 33.4512 33.3448C33.3763 33.3452 33.3245 33.3507 33.2511 33.3661C33.177 33.3817 33.0823 33.4172 32.893 33.4881C32.0097 33.819 31.0524 34 30.0526 34C29.6344 34 29.2237 33.9683 28.8227 33.9073M23.6316 38C26.5965 38 29 35.5376 29 32.5C29 29.4624 26.5965 27 23.6316 27C20.6667 27 18.2632 29.4624 18.2632 32.5C18.2632 33.1106 18.3603 33.6979 18.5395 34.2467C18.6153 34.4787 18.6532 34.5947 18.6657 34.6739C18.6786 34.7567 18.6809 34.8031 18.6761 34.8867C18.6714 34.9668 18.6514 35.0573 18.6113 35.2383L18 38L20.9948 37.591C21.1583 37.5687 21.24 37.5575 21.3114 37.558C21.3865 37.5585 21.4264 37.5626 21.5001 37.5773C21.5701 37.5912 21.6742 37.6279 21.8823 37.7014C22.4306 37.8949 23.0191 38 23.6316 38Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function LockIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M33 27V24C33 21.2386 30.7614 19 28 19C25.2386 19 23 21.2386 23 24V27M23.8 37H32.2C33.8802 37 34.7202 37 35.362 36.673C35.9265 36.3854 36.3854 35.9265 36.673 35.362C37 34.7202 37 33.8802 37 32.2V31.8C37 30.1198 37 29.2798 36.673 28.638C36.3854 28.0735 35.9265 27.6146 35.362 27.327C34.7202 27 33.8802 27 32.2 27H23.8C22.1198 27 21.2798 27 20.638 27.327C20.0735 27.6146 19.6146 28.0735 19.327 28.638C19 29.2798 19 30.1198 19 31.8V32.2C19 33.8802 19 34.7202 19.327 35.362C19.6146 35.9265 20.0735 36.3854 20.638 36.673C21.2798 37 22.1198 37 23.8 37Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function ProfileIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M36 37C36 35.6044 36 34.9067 35.8278 34.3389C35.44 33.0605 34.4395 32.06 33.1611 31.6722C32.5933 31.5 31.8956 31.5 30.5 31.5H25.5C24.1044 31.5 23.4067 31.5 22.8389 31.6722C21.5605 32.06 20.56 33.0605 20.1722 34.3389C20 34.9067 20 35.6044 20 37M32.5 23.5C32.5 25.9853 30.4853 28 28 28C25.5147 28 23.5 25.9853 23.5 23.5C23.5 21.0147 25.5147 19 28 19C30.4853 19 32.5 21.0147 32.5 23.5Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function BulbIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M25.5 38H30.5M31 31.3264C33.3649 30.2029 35 27.7924 35 25C35 21.134 31.866 18 28 18C24.134 18 21 21.134 21 25C21 27.7924 22.6351 30.2029 25 31.3264V32C25 32.9319 25 33.3978 25.1522 33.7654C25.3552 34.2554 25.7446 34.6448 26.2346 34.8478C26.6022 35 27.0681 35 28 35C28.9319 35 29.3978 35 29.7654 34.8478C30.2554 34.6448 30.6448 34.2554 30.8478 33.7654C31 33.3978 31 32.9319 31 32V31.3264Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}

export function CheckIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9476 0.62169L4.5943 8.68336L2.37763 6.31502C1.9693 5.93002 1.32763 5.90669 0.860963 6.23336C0.405963 6.57169 0.27763 7.16669 0.557629 7.64502L3.18263 11.915C3.4393 12.3117 3.88263 12.5567 4.3843 12.5567C4.86263 12.5567 5.31763 12.3117 5.5743 11.915C5.9943 11.3667 14.0093 1.81169 14.0093 1.81169C15.0593 0.738356 13.7876 -0.206643 12.9476 0.610023V0.62169Z"
        fill="rgba(13,48,80,0.8)"
      />
    </svg>
  );
}
export function Hearthand(props: ComponentProps<"svg">) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#F9D209" />
      <path
        d="M22 36.087H24.6103C24.9506 36.087 25.2889 36.1275 25.6188 36.2085L28.3769 36.8788C28.9753 37.0246 29.5988 37.0387 30.2035 36.9213L33.253 36.328C34.0585 36.1711 34.7996 35.7853 35.3803 35.2204L37.5379 33.1216C38.154 32.5233 38.154 31.5523 37.5379 30.953C36.9832 30.4133 36.1047 30.3526 35.4771 30.8102L32.9626 32.6448C32.6025 32.908 32.1643 33.0497 31.7137 33.0497H29.2855L30.8311 33.0497C31.7022 33.0497 32.4079 32.3632 32.4079 31.5158V31.209C32.4079 30.5054 31.9156 29.8919 31.2141 29.7218L28.8286 29.1416C28.4404 29.0475 28.0428 28.9999 27.6431 28.9999C26.6783 28.9999 24.9319 29.7987 24.9319 29.7987L22 31.0248M18 30.5999L18 36.3999C18 36.9599 18 37.24 18.109 37.4539C18.2049 37.642 18.3578 37.795 18.546 37.8909C18.7599 37.9999 19.0399 37.9999 19.6 37.9999H20.4C20.9601 37.9999 21.2401 37.9999 21.454 37.8909C21.6422 37.795 21.7951 37.642 21.891 37.4539C22 37.24 22 36.9599 22 36.3999V30.5999C22 30.0398 22 29.7598 21.891 29.5459C21.7951 29.3577 21.6422 29.2048 21.454 29.1089C21.2401 28.9999 20.9601 28.9999 20.4 28.9999H19.6C19.0399 28.9999 18.7599 28.9999 18.546 29.1089C18.3578 29.2048 18.2049 29.3577 18.109 29.5459C18 29.7598 18 30.0398 18 30.5999ZM33.1914 19.5922C32.5946 18.3433 31.2186 17.6817 29.8804 18.3203C28.5423 18.9589 27.9722 20.4733 28.5325 21.8027C28.8787 22.6244 29.8707 24.2199 30.5781 25.3189C30.8394 25.725 30.9701 25.928 31.161 26.0468C31.3247 26.1487 31.5297 26.2036 31.7224 26.1972C31.9471 26.1898 32.1618 26.0793 32.5911 25.8583C33.7532 25.2602 35.4101 24.3744 36.1208 23.836C37.2707 22.9648 37.5556 21.3635 36.6947 20.1461C35.8337 18.9288 34.3327 18.809 33.1914 19.5922Z"
        stroke="#0D3050"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9D209" strokeWidth="8" />
    </svg>
  );
}
